export const genericStyles = {
  primaryColor: "#7B3BEA",
  bgColor: "#7B3BEA",
  textColor: "#0B304D",
  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
  outsideBgColor: "#f0f2f5",
  activeBgColor: "#E6F7FF",
  successColor: "#52c41a",
  failColor: "#ff4d4f",
  processColor: "#1890ff",
};

export const timezoneOptions = [
  { label: "UTC", value: "UTC" },
  { label: "America/New York", value: "America/New York" },
  { label: "Europe/London", value: "Europe/London" },
  { label: "Asia/Kolkata", value: "Asia/Kolkata" },
];

export const industryOptions = [
  { label: "Technology", value: "technology" },
  { label: "Finance", value: "finance" },
  { label: "Healthcare", value: "healthcare" },
  { label: "Retail", value: "retail" },
  { label: "Manufacturing", value: "manufacturing" },
  { label: "Other", value: "other" },
];

export const employeesSizeOptions = [
  { label: "1-10 employees", value: "1-10" },
  { label: "11-50 employees", value: "11-50" },
  { label: "51-200 employees", value: "51-200" },
  { label: "201-500 employees", value: "201-500" },
  { label: "500+ employees", value: "500+" },
];

export const days = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const TagColorMap = [
  "purple",
  "magenta",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
];

export const ConversationStatus = Object.freeze({
  OPEN: "open",
  PENDING: "pending",
  RESOLVED: "resolved",
  ARCHIVED: "archived",
  BOT_HANDLING: "bot_handling",
});

export const STATUS_COLORS = {
  [ConversationStatus.OPEN]: "#22c55e", // green
  [ConversationStatus.PENDING]: "#f59e0b", // amber
  [ConversationStatus.RESOLVED]: "#64748b", // gray
  [ConversationStatus.ARCHIVED]: "#94a3b8", // light gray
  [ConversationStatus.BOT_HANDLING]: "#3b82f6", // blue
};

export const QUESTION_TYPES = [
  { label: "String", value: "string" },
  { label: "Date", value: "date" },
  { label: "Dropdown", value: "dropdown" },
  { label: "Yes/No", value: "yes/no" },
];

export const SUGGESTED_ACTIONS = [
  { label: "Call Client", value: "call_client" },
  { label: "Send Email", value: "send_email" },
  { label: "Follow Up", value: "follow_up" },
  { label: "Schedule Meeting", value: "schedule_meeting" },
  { label: "Review Document", value: "review_document" },
  { label: "No Action Required", value: "no_action" },
];

export const PRIORITY_OPTIONS = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
  { label: "Critical", value: "critical" },
];

export const SYSTEM_SENDER = {
  id: "01941f40-89c0-7c2d-a8d4-4d3c8b1f92e7",
  email: null,
  avatar: null,
  first_name: "Kelu",
  last_name: "AI",
};

export const JOIN_MEETING_TOKEN = "__KELU_JOIN_MEETING_#7X@4Q!__";
